import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "dropdown__button--label__text"
}
const _hoisted_2 = {
  key: 0,
  class: "pi pi-chevron-up"
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-chevron-down"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "dropdown__menu__item__row" }
const _hoisted_6 = { class: "dropdown__menu__item__left" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "dropdown__menu__item__toggle"
}
const _hoisted_9 = {
  key: 1,
  class: "dropdown__menu__item__selected"
}
const _hoisted_10 = {
  key: 0,
  class: "dropdown__menu__item__description"
}

import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { MenuItem } from '../types/dropdown-interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    buttonLabel: {},
    buttonIcon: {},
    shade: {},
    size: {},
    menuItems: {},
    selectedMenuItem: {},
    group: {},
    dropdownOpenByParent: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dropdownOpen = ref(props.dropdownOpenByParent || false);
const componentId = getCurrentInstance()?.uid;

const toggleDropdown = () => {
    dropdownOpen.value = !dropdownOpen.value;

    if (dropdownOpen.value) {
        document.dispatchEvent(new CustomEvent('closeOtherDropdowns', {
            detail: {
                except: componentId,
                group: props.group
            }
        }));
    }
};

const handleCloseOthers = (event: any) => {
    if (event.detail?.group === props.group && event.detail?.except !== componentId) {
        dropdownOpen.value = false;
    }
}

const clickMenuItem = (item: MenuItem) => {
    if (item.onClick && !item.disabled) {
        item.onClick();
        dropdownOpen.value = false;
    }
}

const toggleMenuItem = (item: MenuItem) => {
    if (item.onToggle) {
        item.onToggle();
    }
}

const getSlotName = (name: string) => {
    return name.replace(/\s+/g, '').toLowerCase();
}

onMounted(() => {
    document.addEventListener('closeOtherDropdowns', handleCloseOthers);
});

onUnmounted(() => {
    document.removeEventListener('closeOtherDropdowns', handleCloseOthers);
});

return (_ctx: any,_cache: any) => {
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'dropdown',
            props.shade === 'lighter' ? 'dropdown--lighter' : ''
        ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
                'dropdown__button',
                dropdownOpen.value ? 'dropdown__button--open' : '',
                props.buttonLabel ? 'dropdown__button--label' : '',
            ]),
      onClick: toggleDropdown
    }, [
      (props.buttonIcon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(['pi', props.buttonIcon])
          }, null, 2))
        : _createCommentVNode("", true),
      (props.buttonLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(props.buttonLabel) + " ", 1),
            (dropdownOpen.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : (_openBlock(), _createElementBlock("i", _hoisted_3))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (dropdownOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
                'dropdown__menu',
                'dropdown__menu--right',
                props.size === 'large' ? 'dropdown__menu--large' : '',
                props.menuItems.length > 7 ? 'dropdown__menu--scrollable' : '',
            ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menuItems, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass([
                    'dropdown__menu__item',
                    item.endOfSection ? 'dropdown__menu__item--end' : '',
                    item.onClick && !item.disabled ? 'dropdown__menu__item--clickable' : '',
                    item.disabled ? 'dropdown__menu__item--disabled' : '',
                ]),
              onClick: ($event: any) => (clickMenuItem(item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (item.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.icon,
                        alt: item.name,
                        "aria-hidden": "true"
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                  (item.status)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass([
                                'dropdown__menu__item__status',
                                item.status === 'ready' ? 'dropdown__menu__item__status--ready' : '',
                                item.status === 'processing' ? 'dropdown__menu__item__status--processing' : '',
                            ])
                      }, _toDisplayString(item.status === 'ready' ? 'Ready' : item.status === 'processing' ? 'Processing' : 'Available'), 3))
                    : _createCommentVNode("", true)
                ]),
                (item.onToggle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_ToggleSwitch, {
                        modelValue: item.checked,
                        "onUpdate:modelValue": [($event: any) => ((item.checked) = $event), ($event: any) => (toggleMenuItem(item))],
                        disabled: item.disabled
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (props.selectedMenuItem !== undefined && props.selectedMenuItem === item.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "pi pi-check" }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              (item.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.description), 1))
                : _createCommentVNode("", true),
              (item.slotFunctionality)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _renderSlot(_ctx.$slots, getSlotName(item.name))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})